/**
 * Same as laravel helper trans
 * @param string
 * @param wildcards
 * @returns {*|string}
 */
function fillTranslateParams(string, wildcards = {}) {
    if (!string) {
        return ''
    }

    let tmpString = string;
    _.forEach(wildcards, (value, key) => {
        tmpString = tmpString.replace(`:${key}`, value);
    })

    return tmpString;
}

function translateService(serviceTitle) {
    return _.get(this, `translate.user_features.services.${serviceTitle}`, serviceTitle)
}

function translateFeature(feature, featureType) {
    return _.get(this, `translate.user_features.featureOptions.${featureType}.${feature}`, feature)
}

function translateFeatures(features, featureType) {
    return features.map(feature => this.translateFeature(feature, featureType));
}

function translateFeatureInProfile(name, value) {
    name = name.replace(/\s+/g, '_');
    return this.translateFeature(value, name)
}

function translateH1Tag(h1Tag) {
    if (typeof window === "undefined" || !h1Tag || _.get(this, 'settings.defaultLocale', 'de') === this.locale) {
        return h1Tag
    }

    try {
        const replacements = _.get(this, 'translate.home.h1TagReplacements', {})

        for (const key in replacements) {
            if (h1Tag.includes(key)) {
                h1Tag = h1Tag.replace(key, replacements[key])
                return h1Tag;
            }
        }
    } catch (e) {
        return h1Tag
    }

    return h1Tag
}

/**
 * Mirrors nuxt helpers/seo/seoHelpers.ts translateH1Tag.
 * Splits the h1 into the replaced category part and the location tail
 * ({h1Tag, h1Location}) so the location can be highlighted; returns
 * {h1Fallback} when no replacement key matches.
 */
function translateH1TagData(h1Tag) {
    if (!h1Tag) {
        return {};
    }

    try {
        const replacements = _.get(this, 'translate.home.h1TagReplacements', {});

        for (const key in replacements) {
            if (h1Tag.includes(key)) {
                const replacement = replacements[key];
                const h1Parts = h1Tag.replace(key, '').split(' ').filter((word) => word);

                let connectionWord = '';
                if (h1Parts.length > 1) {
                    connectionWord = h1Parts.shift() || '';
                }

                return {
                    h1Tag: `${replacement} ${connectionWord}`,
                    h1Location: h1Parts.join(' ') || '',
                };
            }
        }
    } catch (e) {
        return {h1Fallback: h1Tag};
    }

    return {h1Fallback: h1Tag};
}

export default {
    computed: {
        ...mapState(['translate', 'locale', 'settings']),
    },
    methods: {
        fillTranslateParams,
        translateService,
        translateFeature,
        translateFeatures,
        translateFeatureInProfile,
        translateH1Tag,
        translateH1TagData,
    },
}
